export const features = {
  STUDENT_EVENT_TRACKING: 'feature.communities-student-event-tracking',
  COURSES_TO_COMMUNITIES: 'feature.courses-to-communities-link',
  NOTIFICATION_PANE: 'feature.notification-pane',
  COMMUNITIES_AS_A_PRODUCT: 'feature.communities-as-a-product',
  DEV_COMMUNITIES_DEBUGGING: 'dev-communities-debugging',
  COMMUNITIES_EVENTS_RSVP: 'feature.communities-events-rsvp',
  COMMUNITIES_EVENT_EMAILS: 'feature.live-event-emails',
  COMMUNITIES_MODERATOR_ROLE: 'feature.communities-moderator-role',
  LIVE_EVENT_REMINDERS: 'events.live-event-reminders',
  COMMUNITIES_SEARCH: 'feature.communities-post-search',
  PUBLISH_BUTTON: 'feature.publish-button',
  TIPTAP_EDITOR: 'feature.tiptap-in-communities',
  DIRECT_MESSAGING: 'feature.communities-direct-messaging',
  BLOCK_DMS: 'feature.communities-block-dms',
  LEARNER_HUB: 'feature.learner-hub',
  NLA_DMS: 'feature.nla-dms',
  POST_VIDEO_UPLOAD: 'feature.communities-post-video-upload',
  DM_UPLOADS: 'feature.communities-direct-messaging-uploads',
  COMMUNITY_REACTIONS: 'features.community-reactions',
  READ_ONLY_SPACES: 'feature.communities-read-only-spaces',
  NLA_COMMUNITIES: 'feature.nla-communities',
  NLA_COMMUNITY_EVENTS: 'feature.nla-community-events',
};
